// ./src/contexts/VolunteerSlotsContext/VolunteerSlotsContext.tsx
//
// Thin context wrapper around the useVolunteerSlots hook (event-scoped). All
// derived data lives in the hook itself. See VolunteerRolesContext for the pattern.

import React, { createContext, useContext } from "react";

import { useVolunteerSlots, UseVolunteerSlotsOptions, UseVolunteerSlotsReturn } from "@/hooks/useVolunteerSlots";

const VolunteerSlotsContext = createContext<UseVolunteerSlotsReturn | null>(null);

export interface VolunteerSlotsProviderProps extends UseVolunteerSlotsOptions {
  children: React.ReactNode;
}

export const VolunteerSlotsProvider: React.FC<VolunteerSlotsProviderProps> = ({ children, ...options }) => {
  const value = useVolunteerSlots(options);

  return <VolunteerSlotsContext.Provider value={value}>{children}</VolunteerSlotsContext.Provider>;
};

export const useVolunteerSlotsContext = (): UseVolunteerSlotsReturn => {
  const context = useContext(VolunteerSlotsContext);

  if (!context) {
    throw new Error(
      "useVolunteerSlotsContext must be used within a <VolunteerSlotsProvider>. " +
        "Wrap your component tree with <VolunteerSlotsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalVolunteerSlotsContext = (): UseVolunteerSlotsReturn | null => {
  return useContext(VolunteerSlotsContext);
};
